// Окно поверх экрана закрывается системной «Назад» Telegram (12.10, слово владельца: «назад — нативно, красиво»):
// пока окно открыто, кнопка видна в шапке Telegram; закрылось — кнопка как была у экрана.
import { useEffect, useRef } from 'react';
import { bindOverlayBack } from '../telegram/webapp';

export function useOverlayBack(onClose: () => void): void {
  const ref = useRef(onClose);
  ref.current = onClose;
  useEffect(() => bindOverlayBack(() => ref.current()), []);
}
